module.exports = __webpack_public_path__ + "static/desktop/img/material-2-album.cfca64a0.png";